// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mongosh-syntax-highlight-syntax-highlight__Ct9Yg * {\n  background: transparent;\n  border: 0px transparent;\n  padding: 0px;\n  margin: 0px;\n  font-size: inherit;\n  border-radius: 0px;\n  color: inherit;\n}\n", ""]);
// Exports
exports.locals = {
	"syntax-highlight": "mongosh-syntax-highlight-syntax-highlight__Ct9Yg"
};
module.exports = exports;
